// Copied into your app by RapidRailsUI (bin/rails rui:update).
// Don't edit this copy: the next update overwrites it. Fix it in the rapid_rails_ui gem.

// Page scroll lock shared by every open modal (0.94.3). Counted, so two
// stacked dialogs keep the page locked until the last one closes, and the
// page's own overflow value is restored, not blanked. Pure: takes the root
// element (document.documentElement in the browser) so Node can test it.

export function lockScroll(root) {
  const count = Number(root.dataset.ruiScrollLocks || 0)
  if (count === 0) {
    root.dataset.ruiScrollOverflow = root.style.overflow || ""
    root.style.overflow = "hidden"
  }
  root.dataset.ruiScrollLocks = String(count + 1)
}

export function unlockScroll(root) {
  const count = Number(root.dataset.ruiScrollLocks || 0)
  if (count <= 0) return
  if (count === 1) {
    root.style.overflow = root.dataset.ruiScrollOverflow || ""
    delete root.dataset.ruiScrollOverflow
    delete root.dataset.ruiScrollLocks
  } else {
    root.dataset.ruiScrollLocks = String(count - 1)
  }
}
